import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { TextInput } from '@repo/ui/components/Inputs';
import { Spacer } from '@repo/ui/components/Spacer';
import { H5 } from '@repo/ui/components/Typography';

import { PromptProps } from './types';

const Prompt: React.FC<PromptProps> = (props) => {
  return (
    <div style={{ padding: '24px' }}>
      <H5>Describe what you want to see</H5>
      <Spacer height="5px" />
      <TextInput
        isTextArea
        placeholder="Product lying on a reflective surface surrounded by leaves and soft shadows"
        theme={{ height: '122px' }}
        value={props.initialIncludePrompt}
        onChanging={props.onIncludePromptChange}
      />
      <Spacer height="24px" />
      <H5>Do not include</H5>
      <Spacer height="5px" />
      <TextInput
        isTextArea
        placeholder="Contrasting harsh lighting, soil, saturated tone"
        theme={{ height: '122px' }}
        value={props.initialExcludePrompt}
        onChanging={props.onExcludePromptChange}
      />
    </div>
  );
};

export default withEventScope(Prompt, { module: 'prompt' });
